import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Box, Boutton, Link } from '@piconetworks/ui'
import style from '../Pagination.module.scss'
import last from 'lodash/last'
import first from 'lodash/first'

const defaultButton = (props) => {
    const { arrow, children, className } = props
    if (arrow) {
        const _props = { ...props, arrow: arrow.toString() }
        return (
            <Boutton variant="secondary" {..._props} className={cx(style.button)}>
                {children}
            </Boutton>
        )
    } else {
        return (
            <Link {...props} className={cx(style.link, className)}>
                {children}
            </Link>
        )
    }
}

const Desktop = (props) => {

    const { PageButtonComponent = defaultButton, page, visiblePages, pages, changePage, flexFill = false } = props
    const activePage = page + 1
    return (
        <Box.Flexbox.Child flexFill={flexFill}>
            <Box.Flexbox.Container justifyContent="center" alignItems="center">

                <PageButtonComponent
                    arrow
                    onClick={() => {
                        if (activePage === 1) return
                        changePage(activePage - 1)
                    }}
                    disabled={activePage === 1}
                >
                    <span
                        className={cx(
                            style.arrow,
                            { [style.arrowDisabled]: activePage === 1 },
                            'icon-chevron-left'
                        )}
                    />
                </PageButtonComponent>

                {visiblePages.map((page, _index, array) => (
                    <React.Fragment key={page}>
                        {/* This is adding three dot before fifth options */}
                        {last(array) === page &&
                            array.length > 5 &&
                            !array.includes(last(array) - 1) && <PageButtonComponent>...</PageButtonComponent>}
                        <PageButtonComponent
                            key={page}
                            className={cx({
                                [style.active]: page === activePage
                            })}
                            onClick={() => changePage(page)}
                        >
                            {page}
                        </PageButtonComponent>
                        {/* This is adding three dot before after options */}
                        {first(array) === page &&
                            array.length > 5 &&
                            !array.includes(2) && <PageButtonComponent>...</PageButtonComponent>}
                    </React.Fragment>
                ))}
                <PageButtonComponent
                    arrow
                    onClick={() => {
                        if (activePage === pages) return
                        changePage(activePage + 1)
                    }}
                    disabled={activePage === pages}
                >
                    <span
                        className={cx(
                            style.arrow,
                            { [style.arrowDisabled]: activePage === 1 },
                            'icon-chevron-right'
                        )}
                    />
                </PageButtonComponent>
            </Box.Flexbox.Container>
        </Box.Flexbox.Child>
    )
}

Desktop.propTypes = {
    changePage: PropTypes.func.isRequired,
    flexFill: PropTypes.bool,
    page: PropTypes.number.isRequired,
    PageButtonComponent: PropTypes.any,
    pages: PropTypes.number.isRequired,
    visiblePages: PropTypes.array.isRequired
}

export default Desktop
